import React, { useRef } from 'react';
import styled from 'styled-components/macro';

import { viewport } from '../../../../../common/config';
import useAnimation from './useAnimation';

const Wrapper = styled.div`
  position: relative;
  padding: 4rem 0;

  opacity: 0;
`;

const Text = styled.h2`
  font-size: 25rem;
  font-family: 'Dancing Script', cursive;
  text-align: center;

  opacity: 0;

  @media screen and (min-width: ${viewport.sm}) { font-size: 34rem }
  @media screen and (min-width: ${viewport.md}) { font-size: 43rem }
  @media screen and (min-width: ${viewport.lg}) { font-size: 52rem }
`;

const Section = styled.div`
  position: absolute;
  height: 50%;
  width: 0%;
  background: var(--background);

  &.top {
    top: 0;
    left: 0;
  }

  &.bottom {
    bottom: 0;
    right: 0;
  }
`;

const Line = styled.div`
  position: absolute;
  width: 100%;
  height: 2rem;

  background: black;

  &.top { bottom: -1rem }
  &.bottom { top: -1rem }
`;

const Subtitle = () => {
  const wrapper = useRef<HTMLDivElement>(null);
  const text = useRef<HTMLParagraphElement>(null);

  const top = useRef<HTMLDivElement>(null);
  const bottom = useRef<HTMLDivElement>(null);

  useAnimation(wrapper, text, top, bottom);

  return (
    <Wrapper ref={wrapper}>
      <Text ref={text}>Sparkling Cider</Text>

      <Section className="top" ref={top}>
        <Line className="top" />
      </Section>

      <Section className="bottom" ref={bottom}>
        <Line className="bottom" />
      </Section>
    </Wrapper>
  );
}

export default Subtitle;